module.exports = {"131023001":"城区街道","131023100":"永清镇","131023101":"韩村镇","131023102":"后奕镇","131023103":"别古庄镇","131023104":"里澜城镇","131023200":"管家务回族乡","131023201":"曹家务乡","131023202":"龙虎庄乡","131023203":"刘街乡","131023204":"三圣口乡","131023400":"河北永清经济开发区","131023401":"北京亦庄永清高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131023.json
// module id = 322
// module chunks = 0